module.exports = __webpack_public_path__ + "media/CARNET1.efb24916.mp4";